export const networkedDOMProtocolSubProtocol_v0_2 = "networked-dom-v0.2";
